import DeviceImportFailureTable from './DeviceImportFailureTable'

export default DeviceImportFailureTable
